import { MAX_SPACE_CHAT_HISTORY } from "constants/constants";
import SendButton from "graphics/icons/SendButton";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactSwitch from "react-switch";
import { setInputBoxActive } from "slices/generalSlice";
import { selectMeAdmin, selectMembersChatable } from "slices/spaceMediaSlice";
import {
  disableChatForMembers,
  enableChatForMembers,
  selectChatHistory,
  sendChat,
  setNewChat,
} from "slices/spaceSlice";
import SpaceChatMsg from "./SpaceChatMsg/SpaceChatMsg";

const SpaceMcht = () => {
  const dispatch = useDispatch();
  const chatHistory = useSelector(selectChatHistory);
  const meAdmin = useSelector(selectMeAdmin);
  const membersChatable = useSelector(selectMembersChatable);
  const iCanChat = membersChatable || meAdmin;
  const [content, setContent] = useState("");
  const ref = useRef();

  const onEnter = () => {
    let trimmedContent = content.trim();
    if (trimmedContent.length !== 0 && content.length < 500) {
      sendChat(trimmedContent);
      setContent("");
    }
  };

  useEffect(() => {
    if (ref.current) {
      if (iCanChat) {
        ref.current.scrollTop = ref.current.scrollHeight;
        ref.current.style.height = "25px";
        ref.current.style.height = ref.current.scrollHeight + 2 + "px";
      } else {
        ref.current.style.removeProperty("height");
      }
    }
  }, [content, iCanChat]);

  useEffect(() => {
    dispatch(setNewChat(false));
    return () => dispatch(setInputBoxActive(false));
  }, [dispatch]);

  return (
    <div className="space-mcht">
      {meAdmin && (
        <label>
          <span>Chat Disabled For Members</span>
          <ReactSwitch
            height={25}
            handleDiameter={21}
            onChange={() =>
              membersChatable ? disableChatForMembers() : enableChatForMembers()
            }
            checked={!membersChatable}
          />
        </label>
      )}
      <div className="help-text">Live Chat messages are not saved</div>
      <hr />
      <div className="chat-messages">
        <br />
        {chatHistory.map((msg, index) => (
          <SpaceChatMsg
            key={index}
            name={msg.name}
            time={msg.time}
            text={msg.text}
          />
        ))}
        {chatHistory.length === MAX_SPACE_CHAT_HISTORY && (
          <>
            <br />
            <div className="help-text">
              Only the last {MAX_SPACE_CHAT_HISTORY.toString()} messages are
              shown.
            </div>
          </>
        )}
      </div>
      <div className="Txt-input-bar">
        <div className="Txt-input-entry-container">
          <textarea
            className={`Txt-input-entry Pinned-input-entry`}
            value={content}
            maxLength="500"
            placeholder={
              iCanChat ? "Send a Chat Message" : "Only Admins Can Chat"
            }
            onKeyDown={(e) => {
              if (e.key === "Enter" && e.shiftKey === false) {
                onEnter();
                e.preventDefault();
              }
            }}
            ref={ref}
            onChange={(e) => setContent(e.target.value)}
            onFocus={() => dispatch(setInputBoxActive(true))}
            onBlur={() => dispatch(setInputBoxActive(false))}
            disabled={!iCanChat}
          />
          <button
            className={`Txt-make-effice-button ${content ? "active" : ""}`}
            disabled={!content || !iCanChat}
            onClick={onEnter}
          >
            <SendButton />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SpaceMcht;
